import { z } from 'zod';
import { retrievalResDto } from './retrieval.res.dto';

// the BDM1 retrieval in its post-switch shape (retrievalMode NONE, status NO_FULFILLMENT)
export const switchBdm1SampleToVoucherResDto = retrievalResDto;
export type SwitchBdm1SampleToVoucherResDto = z.infer<
  typeof switchBdm1SampleToVoucherResDto
>;
